import { toast } from "react-toastify";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { DELETE_COURSE_FROM_TIER } from "./query";
import { clearCache } from "../../utils";

interface Props {
    tierCourseID: string;
}

const DeleteTierCourse = ({ tierCourseID }: Props) => {
    const { submitMutation } = useGlobalMutation(DELETE_COURSE_FROM_TIER, (cache: any) => {
        clearCache(cache, "allAllerganProTiers");
        clearCache(cache, "allAllerganProTierConfigurations");
    });

    const submitAction = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
        const deleteConfirm = e.currentTarget.deleteConfirm.value;

        if (tierCourseID && deleteConfirm.toLocaleLowerCase() === "confirm") {
            try {
                const variables = {
                    id: tierCourseID,
                };

                await submitMutation(
                    variables,
                    "deleteAllerganProTierConfigurationById.allerganProTierConfiguration",
                    "Delete successfully"
                );

                const modal = document.getElementById(`deleteModal-${tierCourseID}`);
                if (modal) {
                    document.body.classList.remove("modal-open");
                    modal.classList.remove("show");
                    modal.setAttribute("aria-hidden", "true");
                }

                const modalBackdrop = document.querySelector(".modal-backdrop");
                if (modalBackdrop) {
                    modalBackdrop.remove();
                }
            } catch (error) {
                toast.error(error.message);
            }
        } else {
            toast.warn("Please enter CONFIRM to delete");
        }
    };

    return (
        <>
            <button
                type="button"
                className="btn btn-outline-danger"
                data-toggle="modal"
                data-target={`#deleteModal-${tierCourseID}`}
            >
                Delete
            </button>

            <div
                className="modal fade"
                id={`deleteModal-${tierCourseID}`}
                tabIndex={-1}
                role="dialog"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <h5 className="mb-3">
                                Are you sure you want to delete this course? If YES then enter
                                CONFIRM into the box.
                            </h5>
                            <form
                                className="d-flex flex-column align-items-start"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    submitAction(e);
                                    return false;
                                }}
                            >
                                <div className="form-group mb-3">
                                    <input
                                        name="deleteConfirm"
                                        type="text"
                                        className="form-control mb-0"
                                        placeholder="Type CONFIRM"
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <button type="submit" className="btn btn-danger">
                                        Delete
                                    </button>
                                    <div className="btn btn-primary ml-2" data-dismiss="modal">
                                        Cancel
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeleteTierCourse;
